import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import JsonString from '../../components/JsonString.vue';
export default {
  __name: 'JsonStringPage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "字符串JSON转对象，对象转字符串JSON",
        "current-page": "url"
      }, {
        default: _withCtx(() => [_createVNode(JsonString)]),
        _: 1
      });
    };
  }
};